import { ConnectionShareType } from "../../types";
import type { ConnectionShare } from "./useFormatConnectionShares";

const MEMBER_PREFIX = "customuser_";
const TEAM_PREFIX = "team_";
const ACCOUNT_PREFIX = "account_";

/** Maps a connection share to the id ShareWithPicker uses for it. Owners are members. */
export function toPickerId(
  { id, shareType }: Pick<ConnectionShare, "id" | "shareType">,
  accountId?: string | number,
) {
  if (shareType === ConnectionShareType.All) {
    return `${ACCOUNT_PREFIX}${accountId}`;
  }
  if (shareType === ConnectionShareType.Group) return `${TEAM_PREFIX}${id}`;
  return `${MEMBER_PREFIX}${id}`;
}

/** Maps a ShareWithPicker id to a connection share id and type, or null if it isn't one. */
export function parsePickerId(pickerId: string) {
  if (pickerId.startsWith(ACCOUNT_PREFIX)) {
    return { id: "all", shareType: ConnectionShareType.All };
  }
  const prefixes = [
    [MEMBER_PREFIX, ConnectionShareType.Member],
    [TEAM_PREFIX, ConnectionShareType.Group],
  ] as const;
  for (const [prefix, shareType] of prefixes) {
    const id = pickerId.slice(prefix.length);
    if (pickerId.startsWith(prefix) && id) return { id, shareType };
  }
  return null;
}
